const CGU = () => {
  return (
    <div className='max-w-[1280px] mx-auto p-32 space-y-32'>
      <h1 className='text-center'>
        CONDITIONS GÉNÉRALES DE SERVICES ET D’UTILISATION
      </h1>
      <h1 className='text-center'>CLAP.SHOW</h1>
      <p>
        EDPREF DIGITAL (ci-après désignée sous sa dénomination commerciale «{' '}
        <b>CLAP.TECH</b> ») a développé une solution logicielle clap.show qui
        propose aux utilisateurs un service de montage et de diffusion de
        diaporamas/vidéos, à l’attention des professionnels de l’immobilier,
        pour les animations de leurs vitrines/écrans connectés.
      </p>
      <p>
        Les présentes conditions générales s’appliquent à toute souscription au
        service clap.show par un client professionnel (ci-après le «{' '}
        <b>Client</b> ») que ce soit à titre gratuit, pour son propre compte ou
        dans l’hypothèse où le Client agit en tant que partenaire.
      </p>
      <p>
        Il est rappelé que CLAP.TECH n’est pas un organisme de presse, ni
        journaliste, ni réalisateur mais uniquement un éditeur de de logiciels,
        elle n’est aucunement responsable des choix de diffusion et des contenus
        éditoriaux des montages et vidéos réalisés par les Clients.
      </p>
      <h3 className='font-bold underline'>ARTICLE 1 - DÉFINITION</h3>
      <table>
        <tbody>
          <tr>
            <td className='p-32 font-bold'>Abonnement</td>
            <td className='p-32'>
              désigne le contrat d’abonnement payant auquel souscrit le Client
              qui lui accorde pendant la durée de l’Abonnement un droit
              d’utilisation portant de la Solution clap.show.
            </td>
          </tr>
          <tr>
            <td className='p-32 font-bold'>CLAP.TECH</td>
            <td className='p-32'>
              désigne EDPREF DIGITAL, société par actions simplifiées, dont le
              siège social est sis à Montbonnot-Saint-Martin au 545 avenue de
              l’Europe, immatriculée au RCS de GRENOBLE sous le n° 891 153 991.
            </td>
          </tr>
          <tr>
            <td className='p-32 font-bold'>CG</td>
            <td className='p-32'>
              désignent les présentes conditions générales de services et
              d’utilisation de clap.show.
            </td>
          </tr>
          <tr>
            <td className='p-32 font-bold'>Écran</td>
            <td className='p-32'>
              désigne des télévision/écran/vitrine connecté(e) appartenant au
              Client, sur lesquels sont diffusés les Diaporamas. Il est précisé
              que la Solution permet de projeter un Diaporama/Écran. Le prix et
              les modalités d’Abonnement
            </td>
          </tr>
          <tr>
            <td className='p-32 font-bold'>Site</td>
            <td className='p-32'>
              désigne le site internet disponible sur{' '}
              <a href='https://clap.show' className='underline text-primary'>https://clap.show</a>.
            </td>
          </tr>
          <tr>
            <td className='p-32 font-bold'>Solution</td>
            <td className='p-32'>
              désigne l’application logicielle clap.show décrite sur le Site,
              téléchargeable sur un boitier multimédia ou un Écran connecté, et
              les services y associés, permettant le montage et la diffusion de
              Diaporama sur des Écrans connectés.
            </td>
          </tr>
          <tr>
            <td className='p-32 font-bold'>Sources</td>
            <td className='p-32'>
              désignent les fichiers/applications/données qui peuvent être
              intégrées à la Solution en accord avec l’Abonnement, et le cas
              échéant en fonction d’un partenariat entre le Client et CLAP.TECH.
            </td>
          </tr>
        </tbody>
      </table>
      <h3 className='font-bold underline'>ARTICLE 2 - OBJET</h3>
      <div>
        <p>Les présentes CG définissent les modalités selon lesquelles :</p>
        <ul className='pl-24'>
          <li>
            - le Client souscrit à un Abonnement et utilise la Solution
            clap.show ;
          </li>
          <li>
            - et selon lesquelles, CLAP.TECH consent au Client un droit
            d’utilisation à la Solution et réalise les prestations y associées ;
          </li>
        </ul>
        <p className='text-right'>ci-après le « <b>Service</b> ».</p>
      </div>
      <h3 className='font-bold underline'>
        ARTICLE 3 - DOCUMENTS CONTRACTUELS
      </h3>
      <p>
        Les présentes CG ne peuvent être modifiées par une correspondance
        antérieure, ni par une clause postérieure, même contenue dans la
        Commande et/ou les conditions générales d’achat ou tout autre document
        émanant du Client sans l’acceptation préalable et écrite de CLAP.TECH.
        En l’absence de conditions spécifiques négociées de bonne foi entre les
        parties et formellement acceptées par CLAP.TECH, la passation d’une
        Commande emporte l’adhésion sans réserve aux présentes CG. Le fait que
        CLAP.TECH ne se prévale pas à un moment donné de l’une quelconque des
        dispositions des présentes CG ne peut être interprété comme valant
        renonciation à s’en prévaloir ultérieurement.
      </p>
      <h3 className='font-bold underline'>
        ARTICLE 4 - CONDITIONS D’UTILISATION CLAP.SHOW
      </h3>
      <div>
        <h4>
          <b>4.1. </b>
          <u>Prérequis :</u>
        </h4>
        <p>
          Pour utiliser clap.show, le Client doit posséder un Écran connecté ou
          un boitier multimédia (de type GoogleChrome, FireStick,…), et une
          connexion internet.
        </p>
        <h4>
          <b>4.2. </b>
          <u>Commande :</u>
        </h4>
        <p>
          Le Client passe commande sur le Site clap.show et suit les
          instructions formulées lors du process de commande en ligne. Il doit
          préalablement créer un compte sur le Site avec un identifiant et un
          mot de passe. Il sera seul responsable de l’utilisation de ses
          identifiants et de son mot de passe, il s’engage à ne pas les
          divulguer. Les identifiants sont personnels et confidentiels. En cas
          de perte ou de vol des identifiants, le Client s’engage à en informer
          immédiatement CLAP.TECH.
        </p>
        <p>
          Le Client, une fois connecté, peut monter et préparer des Diaporamas
          en remplissant le formulaire prévu à cet effet. Les formats des
          contenus pour agrémenter les Diaporamas sont définis dans les FAQ et
          les formulaires. Le Client peut ensuite visualiser et diffuser les
          Diaporamas qu’il a réalisé sur son écran/vitrine connectée.
        </p>
        <h4>
          <b>4.3. </b>
          <u>Partenariat spécifique :</u>
        </h4>
        <p>
          En cas de demande particulière, CLAP.TECH peut établir un devis sur la
          base des besoins communiqués par le Client, dans ce cas, le Client
          prendra attache directement auprès de CLAP.TECH via le formulaire de
          contact. Le Client retournera à CLAP.TECH un devis signé avec « bon
          pour accord » pour passer Commande. Tout devis réalisé par CLAP.TECH à
          la demande du Client a une durée de validité de trente (30) jours.
        </p>
      </div>
      <h3 className='font-bold underline'>ARTICLE 5 - ABONNEMENT</h3>
      <p>
        Les différents Abonnements sont décrits sur le Site et se compose
        d’offres payantes ou gratuites.
      </p>
      <p>
        En tout état de cause, il s’agit d’Abonnement mensuel sans engagement.
        En ce sens tout Abonnement est automatiquement renouvelé à la fin de la
        période de facturation mensuelle établie selon la date de souscription
        (ci-après « <b>Période de facturation</b> »), à moins qu’il ne soit
        résilié par le Client conformément aux conditions de résiliation
        ci-après indiquées.
      </p>
      <p>
        Le montant de l’Abonnement est débité selon le mode de paiement choisi
        par le Client lors de sa souscription et au début de chaque nouvelle
        période de facturation, sauf résiliation.
      </p>
      <p>
        CLAP.TECH se réserve le droit de faire évoluer ses tarifs. Toute
        évolution fera l’objet d’une information préalable moyennant le préavis
        de trente (30) jours par courriel à l’adresse électronique indiquée lors
        de l’inscription. En cas de refus de toute évolution des tarifs, il sera
        possible de mettre fin à l’Abonnement dans les conditions prévues au
        courriel.
      </p>
      <p>
        La résiliation prendra effet à la fin de la période de facturation en
        cours.
      </p>
      <h3 className='font-bold underline'>ARTICLE 6 - DISPONIBILITÉ</h3>
      <p>
        CLAP.TECH fournit les prestations de maintenance préventive, corrective,
        adaptative et évolutive du Site selon les termes et conditions définis
        par le présent article.
      </p>
      <p>
        Clap.show sera librement accessible aux plages horaires suivantes : 24
        heures sur 24, 7 jours sur 7.
      </p>
      <p>
        Il est expressément admis que, pour des raisons de maintenance technique
        nécessaire au bon fonctionnement de la Solution, l’accès à celle-ci peut
        être momentanément interrompu afin de procéder à une intervention
        technique de maintenance ou d’amélioration, sans que le Client puisse
        prétendre, sous quelque forme que ce soit, à une quelconque indemnité.
        CLAP.TECH informera alors le Client par un bandeau d’information diffusé
        sur le Site dans un délai raisonnable, de la nature et de la durée de
        l’intervention afin que le Client puisse prendre ses dispositions. Il
        est sur ce point expressément précisé que CLAP.TECH effectuera, ces
        opérations de préférence en dehors des horaires de bureau.
      </p>
      <p>
        CLAP.TECH ne saurait être tenue pour responsable d’une interruption de
        service liée au réseau internet. À ce titre, le Client reconnaît être
        averti et conscient des aléas techniques inhérents à Internet et des
        interruptions d’accès qui peuvent en résulter et dont CLAP.TECH ne
        saurait être responsable.
      </p>
      <p>
        CLAP.TECH ne pourra en aucun cas être tenu pour responsable de tout
        impact éventuel quel qu’il soit provenant de cette indisponibilité sur
        les activités du Client.
      </p>
      <p>
        CLAP.TECH reste seul décisionnaire et responsable de ses choix en
        matière d’évolution fonctionnelle de la Solution et du Service fourni.
      </p>
      <p>
        CLAP.TECH met également à disposition des Clients, une boîte à lettre
        électronique contact@clap.show pour permettre l’échange d’informations.
      </p>
      <p>
        Il est en revanche reconnu qu’en cas de suspension continue et prolongée
        ayant un impact réel sur l’utilisation de la Solution, CLAP.TECH pourra
        offrir un crédit, un remboursement, une réduction ou toute autre forme
        de compensation équivalente à la durée de la suspension ou de
        l’interruption.
      </p>
      <h3 className='font-bold underline'>ARTICLE 7 - DROITS CONCÉDÉS</h3>
      <p>
        CLAP.TECH concède au Client un droit personnel, non exclusif, non
        cessible et non transférable d’utilisation de la Solution.
      </p>
      <p>
        CLAP.TECH est et demeure seul titulaire de tout droit de propriété
        relatif à tout élément lié à la Solution.
      </p>
      <p>
        La mise à disposition temporaire de la Solution dans les conditions des
        présentes ne saurait être analysée comme la cession d’un quelconque
        droit de propriété intellectuelle au bénéfice du Client au sens du Code
        français de la propriété Intellectuelle.
      </p>
      <p>
        Les codes sources, notamment, restent l’unique propriété de CLAP.TECH.
      </p>
      <p>
        Le Client s’interdit de reproduire tout élément de la Solution ou toute
        documentation la concernant, par quelque moyen que ce soit, sous quelque
        forme que ce soit, et sur quelque support que ce soit.
      </p>
      <p>
        Le Client n’est en aucun cas autorisé à céder tout ou partie des droits
        et obligations résultant des présentes, que ce soit dans le cadre d’une
        cession temporaire, d’une sous-licence et de tout autre contrat
        prévoyant le transfert desdits droits et obligations.
      </p>
      <p>
        Le Client ne peut utiliser la Solution à laquelle il a accès que
        conformément aux présentes et FAQ disponibles sur le Site.
      </p>
      <p>
        Le Client s’interdit strictement toute autre utilisation, notamment,
        sans que cette liste soit limitative, toute adaptation, modification,
        traduction, arrangement, diffusion et décompilation.
      </p>
      <h3 className='font-bold underline'>ARTICLE 8 - DROITS CONCÉDÉS</h3>
      <p>
        CLAP.TECH met à la disposition du Client une palette de fonctionnalités
        que ce dernier peut choisir d’utiliser, notamment la possibilité de
        récupérer et de supprimer des Diaporamas conservés sur le système de la
        Solution. CLAP.TECH déploiera des mesures techniques et
        organisationnelles commercialement raisonnables, conçues spécifiquement
        pour éviter l’accès, l’utilisation, la modification ou la divulgation
        illégal(e) ou non autorisé(e) des Données clients.
      </p>
      <p>
        Le Client est libre de récupérer les Diaporamas qu’il a stockés à tout
        moment pendant la Durée de l’Abonnement. CLAP.TECH conservera les
        Diaporamas associés pendant toute la durée de relation et jusqu’à la fin
        de la Période de facturation en cas de résiliation. Le Client peut clore
        ou supprimer tout Diaporam à tout moment pendant la durée de
        l’Abonnement.
      </p>
      <p>
        L’annexe sur la protection des données disponible via sur{' '}
        <a href='https://clap.show/CGU' className='underline text-primary'>
          https://clap.show/CGU
        </a>{' '}
        , s’applique au traitement des données personnelles.
      </p>
      <h3 className='font-bold underline'>ARTICLE 9 - RESPONSABILITÉ</h3>
      <p>
        CLAP.TECH qui s’engage à apporter tout le soin possible à l’exécution de
        ses obligations, est soumise à une obligation de moyens.
      </p>
      <p>
        CLAP.TECH s’engage à réaliser le Service dans le respect des règles de
        l’art et de l’état de la technique.
      </p>
      <p>
        La responsabilité totale de CLAP.TECH pour toute réclamation,
        responsabilité ou frais, quelle qu’en soit la nature, est limitée, pour
        les dommages directs, à un montant représentant le prix payé par le
        Client au titre de l’année contractuelle en cours. Les préjudices
        indirects subis par le Client sont donc exclus de toute demande
        d’indemnisation. Sont qualifiées de préjudices indirects, sans que cette
        liste soit limitative, notamment la perte de chiffre d’affaires, la
        perte d’exploitation, le préjudice commercial, le manque à gagner ou
        toute prétention formulée par un tiers quel qu’il soit à l’encontre du
        Client.
      </p>
      <p>
        Les Parties reconnaissent que les stipulations de la présente clause
        sont déterminantes dans leur volonté de conclure la Commande et que le
        prix convenu reflète la répartition du risque entre les Parties et la
        limitation de responsabilité en résultant.
      </p>
      <p>
        Les Parties reconnaissent avoir souscrit, auprès d’établissements
        notoirement solvables, les assurances professionnelles couvrant leur
        responsabilité civile, affirment que le paiement des primes est et
        restera à ce jour effectif, et s’engagent à en justifier auprès de
        l’autre Partie sur demande de cette dernière.
      </p>
      <h3 className='font-bold underline'>ARTICLE 10 - RÉFÉRENCES</h3>
      <p>
        Le Client autorise CLAP.TECH à faire mention de son nom sur une liste de
        références qu’il peut diffuser notamment auprès de sa clientèle et de
        ses prospects.
      </p>
      <h3 className='font-bold underline'>ARTICLE 11 - RÉSILIATION</h3>
      <p>
        Le Client peut mettre fin à son Abonnement à tout moment avant la fin de
        la Période de facturation en cours, en adressant un mail à CLAP.TECH aux
        coordonnées suivantes : contact@clap.tech. La résiliation ne prendra
        effet qu’à la fin de la Période de facturation en cours et le Client
        continuera d’avoir accès à la Solution jusqu’à la fin de cette période.
        Les paiements sont non remboursables et CLAP.TECH n’accorde aucun
        remboursement ou crédit pour les périodes d'utilisation partielle, ou
        pour tout Diaporama, Source ou Écran non utilisés.
      </p>
      <p>
        En revanche, sans limiter la portée de ce qu’il précède, CLAP.TECH
        pourra limiter ou résilier l’accès du Client à la Solution, en cas de
        manquement du Client aux obligations (obligation de paiement) le
        concernant ou en cas de motifs légitime (demande des autorités, compte
        frauduleux, utilisation contraire de la Solution…). CLAP.TECH adressera
        un courrier électronique mentionnant les motifs et procèdera à la
        suspension ou à la résiliation de l’accès à la Solution.
      </p>
      <p>
        En cas de résiliation à la demande du Client résultant d’un manquement
        de CLAP.TECH à ses obligations essentielles, CLAP.TECH pourra rembourser
        la partie de la facturation concernant la durée de suspension et de
        restriction.
      </p>
      <h3 className='font-bold underline'>ARTICLE 12 - FORCE MAJEURE</h3>
      <p>
        La responsabilité de CLAP.TECH ne peut être engagée en cas d'inexécution
        ou de mauvaise exécution, soit au fait du Client, soit au fait
        insurmontable et imprévisible d'un tiers, soit à un cas de force
        majeure.
      </p>
      <p>
        De façon expresse, seront considérés comme cas de force majeure, outre
        ceux habituellement retenus par la jurisprudence des cours et tribunaux
        français et conformément à la définition de l’article 1218 du Code civil
        ; les grèves totales ou partielles internes ou externes à CLAP.TECH les
        blocages des moyens de transport pour quelque raison que ce soit, les
        pandémies et épidémies donnant lieux à des décisions sanitaires
        extraordinaires, les guerres, l’indisponibilité ou la rupture de stock
        de matériels commandés chez les fournisseurs ou sous-traitants de
        CLAP.TECH, la mise en liquidation judiciaire de l’un de ses fournisseurs
        ou sous-traitants, le blocage ou la perturbation des moyens de
        communication, de télécommunications ou postaux.
      </p>
      <p>
        Dès lors qu’une Partie est victime d’un cas de force majeure, les
        Parties suspendront l’accès à la Solution. Si l’évènement qui donne lieu
        au cas de force majeure se prolonge pendant plus d’un (1) mois, l’une ou
        l’autre des Parties pourra résilier l’Abonnement par LRAR faisant état
        du cas de force majeure.
      </p>
      <h3 className='font-bold underline'>
        ARTICLE 13 - LITIGES ET DROIT APPLICABLE
      </h3>
      <p>LE PRÉSENT CONTRAT EST SOUMIS À LA LOI FRANÇAISE.</p>
      <p>LA LANGUE DU PRÉSENT CONTRAT EST LA LANGUE FRANÇAISE.</p>
      <p>
        TOUT DIFFÉREND AU SUJET DU CONTRAT ET NOTAMMENT DE LEUR APPLICATION,
        INTERPRÉTATION, DE LEUR EXÉCUTION ET DE CELLES DU CONTRAT OU AU PAIEMENT
        DU PRIX, SERA PORTÉ DEVANT LE TRIBUNAL DE COMMERCE DE GRENOBLE, A
        L'EXCLUSION DE TOUTE AUTRE JURIDICTION, MÊME EN CAS DE PLURALITÉ DE
        DÉFENDEURS OU D'APPEL EN GARANTIE, QUEL QUE SOIT LE LIEU DE LA COMMANDE,
        DE LA LIVRAISON, ET DU PAIEMENT ET LE MODE DE PAIEMENT.
      </p>
    </div>
  )
}

export default CGU
